module.exports = __webpack_public_path__ + "media/images/greenboat-eadf847bcd847a44d78c6872bc25d693.png";